import { useCallback, useState } from "react";
import { useSmartWallet } from "@/contexts";
import { sendBatchTransaction, sendTransaction } from "thirdweb";
import { chain, client } from "@/contexts/SmartWallet";
import { waitForReceipt } from "thirdweb";

const useContractWrite = () => {
  const { smartWalletAddress, account } = useSmartWallet();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null as any);

  const mutateAsync = useCallback(
    async (args: any) => {
      let txReceipt;
      try {
        if (!smartWalletAddress || !account) {
          console.error("Wallet has not fully initialized yet");
          return;
        }
        setIsLoading(true);
        setError(null);

        if (args?.length > 1) {
          const userOpResponse = await sendBatchTransaction({
            account,
            transactions: [args[0], args[1]],
          });

          txReceipt = userOpResponse?.transactionHash;
          await waitForReceipt({
            client,
            chain,
            transactionHash: userOpResponse?.transactionHash as any,
          }).then(
            (res) => {
              txReceipt = res;
              console.log("txReceipt- 1", txReceipt);
            },
            (err) => {
              console.log("error at waitForReceipt", err);
            },
          );
        } else {
          const userOpResponse = await sendTransaction({
            account,
            transaction: args[0],
          });
          txReceipt = userOpResponse?.transactionHash;
          await waitForReceipt({
            client,
            chain,
            transactionHash: userOpResponse?.transactionHash as any,
          }).then(
            (res) => {
              txReceipt = res;
            },
            (err) => {
              setError(err);
            },
          );
        }
        console.log("txReceipt- ", await txReceipt);
      } catch (error: any) {
        setError(error);
        console.log("txwrite catch block - ", error, args);
        throw error;
      } finally {
        setIsLoading(false);
      }
      return {
        //@ts-ignore
        txHash: txReceipt?.transactionHash,
        afterWait: txReceipt,
      };
    },
    [smartWalletAddress],
  );

  return { mutateAsync, isLoading, error };
};

export default useContractWrite;
